import { h, render } from "preact";

export default function ModelRowContentVideo({ video, className }) {
  const { sources, previewImage } = video;

  // In the future we could check the element size and pick a suitable source but for now we're
  // just sorting and grabbing the smallest one.
  const mp4s = sources
    .filter((source) => source.format === "mp4")
    .sort((a, b) => a.width - b.width);

  return (
    <video
      className={className}
      src={mp4s[0].url}
      poster={getSizedImageUrl(previewImage.url, "x800")}
      muted
      autoplay
      loop
      playsinline
    ></video>
  );
}
